import { Ref, forwardRef } from 'react'
import { Tr, Th } from 'app/common/ui-components/table'

import { Column } from './columns'


type Props = {
  columns: Array<Column>
  titles: Record<Column, string>
  stuck: boolean
  shadow: boolean
  reference?: Ref<'tr' | HTMLTableRowElement>,
  columnProps: Record<Column, {
    className?: string
    alignLeft?: boolean
    alignRight?: boolean
    alignCenter?: boolean
  }>
}

export const TableHeader = forwardRef<'tr', Props>(({
  columns,
  reference,
  titles,
  stuck,
  shadow,
  columnProps,
}: Props) => {
  return (
    <Tr reference={reference} header>
      {columns.map((key, index) => (
        <Th
          key={key}
          bgFilled={stuck}
          borderShadowBottom={shadow}
          className={`index_${index}`}
          {...columnProps[key]}
        >
          {titles[key]}
        </Th>
      ))}
    </Tr>
  )
})
